<template>
  <b-container class="auth">
    <b-form @submit.prevent="onSubmit">
      <b-form-row>
        <b-col offset="0" cols="6">
          <form-auth ref="formAuth" v-model="dataAuth"></form-auth>
          <div class="forgetpassword mb-3">
            <b-button @click="modalForgetPassword" variant="link">
              Mot de passe oublié ?
            </b-button>
          </div>
          <b-form-group class="mb-1 btn-login">
            <b-button
              class="pull-center btn-connexion"
              type="submit"
              block
              variant="success"
              >Connexion
              <i v-if="authLoad" class="fa fa-spinner fa-pulse fa-fw"></i
            ></b-button>
          </b-form-group>
        </b-col>
      </b-form-row>
    </b-form>
    <modal-forget-password ref="modalForgetPassword" v-model="dataAuth"></modal-forget-password>
    <modal-update-password ref="modalUpdatePassword" :upgradePassword="upgradePassword" v-model="dataAuth"></modal-update-password>
  </b-container>
</template>

<script>

import FormAuth from './FormAuth.vue'
import ModalForgetPassword from './ModalForgetPassword.vue'
import ModalUpdatePassword from './ModalUpdatePassword.vue'

export default {
  name: 'auth',
  data () {
    return {
      dataAuth: {},
      authLoad: false,
      upgradePassword: false,
      token: null
    }
  },
  mounted: function () {
    const vm = this
    const token = sessionStorage.getItem('token')
    if (token) {
      vm.parseToken(token)
    } else {
      setTimeout(() => {
        vm.$refs.formAuth.$refs.login.focus()
      }, 0)
    }
  },
  methods: {
    modalForgetPassword: function () {
      this.$refs.modalForgetPassword.show()
    },
    modalUpdatePassword: function () {
      this.$refs.modalUpdatePassword.show()
    },
    onSubmit: function () {
      const vm = this

      vm.authLoad = true
      window.$.ajax({
        method: 'POST',
        url: `${process.env.API_AUTH}/labco-token`,
        data: {
          login: vm.dataAuth.login,
          correspondant: vm.dataAuth.correspondant,
          password: vm.dataAuth.password
        }
      })
        .done(function (data) {
          if (data.data && data.data.password_no_secure) {
            vm.upgradePassword = true
            setTimeout(() => {
              vm.$refs.modalUpdatePassword.show()
            }, 0)
          } else {
            vm.password = ''
            vm.parseToken(data.jwt)
          }
        })
        .fail(function (xhr) {
          const errorMessage = window.fail(xhr)
          vm.$bvToast.toast(errorMessage, {
            title: 'Oups !',
            variant: 'warning',
            solid: true
          })
        })
        .always(function () {
          vm.authLoad = false
        })
    },
    focusLogin: function () {
      this.$refs.formAuth.$refs.focusThis.focus()
    },
    parseToken: function (token) {
      const vm = this

      const dataToken = JSON.parse(atob(token.split('.')[1]))
      if (dataToken.exp * 1000 > Date.now()) {
        vm.token = token

        sessionStorage.setItem('token', token)
        vm.$root.user = {
          login: dataToken.login,
          correspondant: dataToken.correspondant,
          right: dataToken.right,
          roles: dataToken.roles,
          rso: dataToken.rso,
          nom: dataToken.nom
        }
      }
    }
  },
  components: {
    FormAuth,
    ModalForgetPassword,
    ModalUpdatePassword
  }
}
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/Auth/Auth.vue